import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import { Table } from 'reactstrap';

const TableDashboard = ({data, column, OnClickDetail}) => {
    const [tableData, setTableData] = useState([]);
    const [tableSlice, setTableSlice] = useState([]);
    const [sortField, setSortField] = useState("");
    const [sortOrder, setSortOrder] = useState("asc");
    const [tableRange, setTableRange] = useState([]);
    const [inPage, setInPage] = useState(1);
    const rowPerPage = 25;

    // const HandleSorting = (field, order) => {
    //     if(field){
    //         const sorted = [...tableData].sort((a, b) => {
    //             if (a[field] === null) return 1;
    //             if (b[field] === null) return -1;
    //             if (a[field] === null && b[field] === null) return 0;
    //             return (
    //                 a[field].toString().localeCompare(
    //                     b[field].toString(), 
    //                     "en", 
    //                     {
    //                         numeric: true,
    //                     }
    //                 ) * (order === "asc" ? 1 : -1)
    //             );
    //         });
    //         setTableData(sorted);
    //     }
    // };

    const HandleSorting = (field, order) => {
        if (field) {
            const sorted = [...tableData].sort((a, b) => {
                const aVal = a[field];
                const bVal = b[field];

                if (aVal === null) return 1;
                if (bVal === null) return -1;
                if (aVal === null && bVal === null) return 0;

                // ตรวจว่าเป็นวันที่รูปแบบ dd/MM/yyyy
                const dateRegex = /^\d{2}\/\d{2}\/\d{4}$/;
                const isDate = dateRegex.test(aVal) && dateRegex.test(bVal);

                if (isDate) {
                    // แปลงเป็น Date object
                    const [aDay, aMonth, aYear] = aVal.split("/").map(Number);
                    const [bDay, bMonth, bYear] = bVal.split("/").map(Number);
                    const dateA = new Date(aYear, aMonth - 1, aDay);
                    const dateB = new Date(bYear, bMonth - 1, bDay);
                    return (dateA - dateB) * (order === "asc" ? 1 : -1);
                } else {
                    // ถ้าไม่ใช่วันที่ ใช้ localeCompare ตามเดิม
                    return (
                        aVal.toString().localeCompare(
                            bVal.toString(),
                            "en", 
                            { 
                                numeric: true 
                            }
                        ) * (order === "asc" ? 1 : -1)
                    );
                }
            });
            setTableData(sorted);
        }
    };

    const HandleSortingChange = (key) => {
        const sortBy = (key === sortField && sortOrder === "asc") ? "desc" : "asc";
        setSortField(key);
        setSortOrder(sortBy);
        setInPage(1);
        HandleSorting(key, sortBy);
    };

    const CalculateRange = (data, rowsPerPage) => {
        const range = [];
        const num = Math.ceil(data.length / rowsPerPage);
        for(let i = 1; i <= num; i++){
            range.push(i);
        }
        return range;
    };

    const HandleSearchChange = (event) => {
        let arrSearch = data.filter((item) => {
            let dataMap = "";
            column.forEach(element => {
                if(element.sortable === true){
                    dataMap += " " + item[element.key];
                }
            });
            dataMap = dataMap.toLocaleLowerCase();
            return dataMap.includes(event.target.value);
        });
        setTableData(arrSearch);
        setInPage(1);
    };

    const SliceData = (data, page, rowsPerPage) => {
        return data.slice((page - 1) * rowsPerPage, page * rowsPerPage);
    };
    useEffect(() => {
        setTableData(data);
    }, [data]);

    useEffect(() => {
        const range = CalculateRange(tableData, rowPerPage);
        setTableRange([...range]);

        const slice = SliceData(tableData, inPage, rowPerPage);
        setTableSlice([...slice]);
    }, [tableData, setTableRange, inPage, setTableSlice, rowPerPage]);


    // useEffect(() => {
    //     setTableData(data);
    // }, [data]);

    // const HandleSorting = (field, order, rowPerPage) => {
    //     if(field){
    //         const sorted = [...tableData].sort((a, b) => {
    //             if (a[field] === null) return 1;
    //             if (b[field] === null) return -1;
    //             if (a[field] === null && b[field] === null) return 0;
    //             return (
    //                 a[field].toString().localeCompare(
    //                     b[field].toString(), 
    //                     "en", 
    //                     {
    //                         numeric: true,
    //                     }
    //                 ) * (order === "asc" ? 1 : -1)
    //             );
    //         });
    //         setTableData(sorted);
    //     }
    // };

    // const HandleSortingChange = (key) => {
    //     const sortBy = (key === sortField && sortOrder === "asc") ? "desc" : "asc";
    //     setSortField(key);
    //     setSortOrder(sortBy);
    //     // setInPage(1);
    //     HandleSorting(key, sortBy);
    // };

    return (
        <React.Fragment>
            <div className="table-responsive mt-2">
                <Table className="align-middle table-hover table-req">
                    <thead>
                        <tr>
                            {column.map((val, key) => {
                                const icon = (val.sortable === true) ? (sortField === val.key && sortOrder === "asc") ? "mdi-sort-ascending" : (sortField === val.key && sortOrder === "desc") ? "mdi-sort-descending" : "mdi-sort" : "";
                                return(
                                    <th key={"th" + val.key + key} 
                                        className={val.classHeader} 
                                        width={val.width} 
                                        onClick={val.sortable === true ? () => HandleSortingChange(val.key) : null} >
                                        {val.name}
                                        <i style={{marginLeft: 5}} className={"mdi " + icon}></i>
                                    </th>
                                )
                            })}
                        </tr>
                    </thead>
                    <tbody>
                        {(tableSlice.length > 0) ? tableSlice.map((valRow, keyRow) => {
                            return (
                                <tr key={"tr" + keyRow} onClick={(e) => { OnClickDetail(valRow); }}>
                                    {column.map((valColumn, keyColumn) => {
                                        return (
                                            <td key={"td" + valColumn.key + keyColumn} 
                                                className={valColumn.classBody} 
                                                width={valColumn.width} >
                                                {valColumn.cell(valRow, keyRow)}
                                            </td>
                                        )
                                    })}
                                </tr>
                            )
                        }) : <tr><td colSpan={column.length - 1}>No result found!</td><td></td></tr>}
                    </tbody>
                </Table>
                <div className="align-items-center justify-content-between d-flex mb-1">
                    <div className="flex-shrink-0">
                        <div className="text-muted show-result-table">
                            Showing&nbsp;
                            <span className="fw-semibold">{tableData.length > 0 ? ((inPage - 1) * rowPerPage) + 1 : 0}</span>
                            &nbsp;to&nbsp;
                            <span className="fw-semibold">{(inPage * rowPerPage) > tableData.length ? tableData.length : inPage * rowPerPage}</span> of <span className="fw-semibold">{tableData.length}</span>
                            &nbsp;Results
                        </div>
                    </div>
                    <ul className="pagination pagination-separated pagination-sm mb-0">
                        <li className="page-item">
                            <Link to="#" className="page-link" onClick={() => { setInPage(1); }}>First</Link>
                        </li>
                        <li className="page-item">
                            <Link to="#" className="page-link" onClick={() => { setInPage((inPage - 1 <= 0) ? 1 : inPage - 1 ); }}>←</Link>
                        </li>
                        {tableRange.map((val, key) => {
                            return (
                                <li key={key} className={"page-item" + (inPage === val ? " active" : "")}>
                                    <Link to="#" className="page-link" onClick={() => { setInPage(val); }}>{val}</Link>
                                </li>
                            );
                        })}
                        <li className="page-item">
                            <Link to="#" className="page-link" onClick={() => { setInPage((inPage + 1 >= tableRange.length) ? tableRange.length : inPage + 1 ); }}>→</Link>
                        </li>
                        <li className="page-item">
                            <Link to="#" className="page-link" onClick={() => { setInPage(tableRange.length); }}>Last</Link>
                        </li>
                    </ul>
                </div>
            </div>
        </React.Fragment>
    );
};

export default TableDashboard;